import { Component, OnInit } from '@angular/core';
import { Pesagem91p } from '../../../../../types/Pesagem91p.type';
import { Empresa } from '../../../../../types/Empresa.type';
import { IntegradorService } from '../../../../../services/integrador.service';
import { ToastService } from '../../../../../services/toast.service';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';

@Component({
  selector: 'app-pesagem91pform',
  templateUrl: './pesagem91pform.component.html',
  styleUrl: './pesagem91pform.component.css'
})
export class Pesagem91pFormComponent implements OnInit {
  pesagem: Pesagem91p = {} as Pesagem91p
  pesagemCadastro: Pesagem91p = {} as Pesagem91p;
  empresas: Empresa[] = [];

  constructor(private integradorService: IntegradorService, private toastService: ToastService, private activatedRoute: ActivatedRoute, private location: Location){}

  ngOnInit(){
    this.buscaPesagem()
    this.buscaEmpresas();
  }

  buscaPesagem(){
    let id = this.activatedRoute.snapshot.paramMap.get('id');

    if(id){
      this.integradorService.getPesagem91p(id).subscribe({
        next: (data) => {
          this.pesagem = data
        },
        error: (error) => {
          console.error(error)
          this.toastService.erro("Erro", error.error.message)
        }
      })
    }
  }

  buscaEmpresas(){
    this.integradorService.getEmpresas().subscribe({
      next: (data) => {
        this.empresas = data
      },
      error: (error) => {
        console.error(error)
        this.toastService.erro("Erro", error.error.message)
      }
    })
  }

  salvar() {
    Object.assign(this.pesagemCadastro, this.pesagem);

    let empresaSelecionada = this.buscaEmpresaSelecionada(this.pesagemCadastro.empresaErp);

    if(empresaSelecionada != undefined){
      this.pesagemCadastro.idEmpresa = empresaSelecionada.id;
    }

    this.pesagemCadastro.tanqueErp = this.pesagemCadastro.tanqueErp?.trim() != '' ? this.pesagemCadastro.tanqueErp : null;
    this.pesagemCadastro.cdMaterialErp = this.pesagemCadastro.cdMaterialErp?.trim() != '' ? this.pesagemCadastro.cdMaterialErp : null;
    this.pesagemCadastro.idTanquePi = this.pesagemCadastro.idTanquePi?.trim() != '' ? this.pesagemCadastro.idTanquePi : null;
    this.pesagemCadastro.cdMaterialPi = this.pesagemCadastro.cdMaterialPi?.trim() != '' ? this.pesagemCadastro.cdMaterialPi : null;

    if (this.pesagem.id) {

      this.integradorService.putPesagem91p(this.pesagemCadastro).subscribe({
        next: () => {
          this.toastService.sucesso('Sucesso', 'Pesagem atualizada com sucesso');
          this.fecharDialog();
        },
        error: (value) => {
          this.toastService.erro('Erro', 'Erro ao salvar: ' + value.error.message);
        },
      });
    } else {

      this.integradorService.postPesagem91p(this.pesagemCadastro).subscribe({
        next: (valor) => {
          Object.assign(this.pesagem, valor);
          this.toastService.sucesso('Sucesso', 'Pesagem salva com sucesso');
          this.fecharDialog();
        },
        error: (value) => {
          this.toastService.erro('Erro', 'Erro ao salvar: ' + value.error.message);
        },
      });
    }
  }

  buscaEmpresaSelecionada = (empresaErp: string): Empresa | undefined => {
    return this.empresas.find(empresa => empresa.empresaErp === empresaErp);
  };

  fecharDialog() {
    this.pesagem = {} as Pesagem91p;
    this.location.back();
  }
}
